const lazyVideos = Array.from(document.querySelectorAll("video.lazy-video"));

if ("IntersectionObserver" in window) {
  var lazyVideoObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;

      if (entry.isIntersecting) {
        if (video) {
          // Lazy load the poster
          if (video.dataset.poster) {
            video.poster = video.dataset.poster;
          }

          // Set the source URLs for each <source> element
          const sources = video.querySelectorAll("source");
          sources.forEach((source) => {
            source.src = source.dataset.src;
          });

          // Load and autoplay the video
          video.load();
          video.play();

          // Remove lazy class and unobserve the video
          video.classList.remove("lazy-video");
          lazyVideoObserver.unobserve(video);
        }
      } else {
        // Check if video exists and is currently playing before pausing
        if (video && !video.paused) {
          video.pause();
        }
      }
    });
  });

  lazyVideos.forEach((lazyVideo) => {
    lazyVideoObserver.observe(lazyVideo);
  });
}
